export default "__VITE_ASSET__FaaTkb6y__"